import { IModel, IAttribute } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from 'app/model/linkedservice/linkedservice';

import { Owned } from 'app/model/base/named';

@Metamodel.model({})
export class FaultTolerenceSettings extends Owned {
    public static readonly MODEL: IModel;
    public static readonly ENABLE_SKIP_ROW: IAttribute;
    public static readonly SKIP_ROW_STORAGE_PATH: IAttribute;
    public static readonly ENABLE_SKIP_INCONSISTENT_FILE: IAttribute;
    public static readonly ENABLE_SKIP_MISSING_FILE: IAttribute;
    public static readonly ENABLE_SKIP_FORBIDDEN_FILE: IAttribute;
    public static readonly ENABLE_SKIP_FILES_WITH_INVALID_NAMES: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENABLE_SKIP_ROW',
        display: stringResources.CopyActivity_FaultTolerance_EnableSkipRows
    })
    public enableSkipIncompatibleRow?: boolean;

    @Metamodel.attribute({
        reference: true
    })
    public incompatibleRowLoggingLinkedService?: LinkedService;

    @Metamodel.attribute({
        templatable: true,
        association: 'SKIP_ROW_STORAGE_PATH',
        display: stringResources.CopyActivity_FaultTolerance_StorageFolderPath
    })
    public incompatibleRowLoggingfolderPath?: string;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENABLE_SKIP_INCONSISTENT_FILE',
        display: stringResources.CopyActivity_FaultTolerance_EnableSkipInconsistentFiles
    })
    public enableSkipInconsistentFile?: boolean = false;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENABLE_SKIP_MISSING_FILE',
        display: stringResources.CopyActivity_FaultTolerance_EnableSkipMissingFiles
    })
    public enableSkipMissingFile?: boolean;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENABLE_SKIP_FORBIDDEN_FILE',
        display: stringResources.CopyActivity_FaultTolerance_EnableSkipForbiddenFiles
    })
    public enableSkipForbiddenFile?: boolean;

    @Metamodel.attribute({
        templatable: true,
        association: 'ENABLE_SKIP_FILES_WITH_INVALID_NAMES',
        display: stringResources.CopyActivity_FaultTolerance_EnableSkipFilesWithInvalidNames
    })
    public enableSkipFilesWithInvalidNames?: boolean;

    public useNewFaultTolerance?: boolean = true;
}
